import { render } from "./SoundLoading.vue?vue&type=template&id=19907784&scoped=true"
const script = {}

import "./SoundLoading.vue?vue&type=style&index=0&id=19907784&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19907784"]])

export default __exports__